<template>
  <div
    class="run-report d-flex flex-column align-items-stretch flex-grow-1"
    style="width: 100%"
  >
    <div
      class="d-flex selector-container align-items-center"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="运行报表"></SectionTitle>
      <!-- 查询条件区域 -->
      <el-form
        class="form-query d-flex section-container"
        size="small"
        :class="{ dark: skinType }"
        :inline="true"
      >
        <el-form-item label="项目" :class="{ 'light-label': skinType }">
          <el-select v-model="selectProjectId">
            <el-option
              v-for="(project, index) of projectList"
              :key="'project-' + index"
              :label="project.ModelName"
              :value="project.IdStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="query-item"
          label="报表类型:"
          :class="{ 'light-label': skinType }"
        >
          <el-select
            @change="reportTypeChange()"
            v-model="selectReportTypeId"
            clearable
            placeholder=""
            ref="selectUpResId"
            :style="{width:selectReportTypeId=='HWJ_ReportType1'?'12rem':'auto' }"
          >
            <el-option
              v-for="item in reportTypes"
              :key="item.ReportId"
              :label="item.ReportName"
              :value="item.ReportId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          class="query-item isreplace"
          label="日期"
          :class="{ 'light-label': skinType }"
        >
          <el-date-picker
            v-model="selectDate"
            :type="periodType"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <div style="position: fixed; right: 3rem">
          <el-form-item class="button-container">
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item class="button-container">
            <el-button @click="exportTable">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!--表格展示区域 -->
    <div
      style="overflow-y: auto"
      class="none-height flex-grow-1 section-container d-flex flex-column"
      :class="{ dark: skinType }"
      v-if="reportDetail"
    >
      <NativeElTable v-show="selectReportTypeId==='XiCheng_ReportType1'||selectReportTypeId==='HWJ_ReportType1'"
      :tableData="reportDetail"></NativeElTable>
      <el-table
        v-show="selectReportTypeId!=='XiCheng_ReportType1'&&selectReportTypeId!=='HWJ_ReportType1'"
        size="small"
        ref="table"
        :data="reportDetail.list"
        :class="{ 'dark': skinType }"
        :span-method="spanMethod"
        stripe
        style="width: 100%"
        height="0"
        class="flex-grow-1 d-flex flex-column"
        header-cell-class-name="header-text"
        :row-class-name="
          (...nu) => {
            return skinType ? 'dark text-white' : '';
          }
        "
      >
        <el-table-column type="index" label="#" width="60"> </el-table-column>
        <RecursionTableColumn
        v-for="(colData, index) of reportDetail.headers" :key="`col-${index}`"
        :recursionInfo="colData">
        </RecursionTableColumn>
      </el-table>
    </div>
    <NoDataTemporarily class="flex-grow-1" v-else></NoDataTemporarily>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { exportExcel, formatDate } from '@/utils/utils';
import { getReportTypes, getReportDetail } from '@/api/reports/reports';
import RecursionTableColumn from '@/components/utils/recursion-table-column.vue';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import NativeElTable from '@/components/utils/native-el-table.vue';

export default {
  components: {
    SectionTitle,
    RecursionTableColumn,
    NoDataTemporarily,
    NativeElTable,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      selectReportTypeId: '',
      selectProjectId: '',
      selectReportType: null,
      selectDate: [formatDate(new Date(), 'yyyy-MM-01'), formatDate(new Date(), 'yyyy-MM-dd')],
      // 报告类型
      reportTypes: [],
      //   表格测试数据
      tableData: [],
      // 报告详情
      reportDetail: null,
      // 工单阶段选项初始化值
      sendTreedata1: [
        {
          resId: 1,
          label: '已提交工单',
        },
        {
          resId: 2,
          label: '未提交工单',
        },
      ],
      periodType: 'daterange',
    };
  },
  created() {
    this.requestProjectList();
  },
  watch: {
    selectProjectId(val) {
      this.reportDetail = null;
      this.$store.dispatch('projects/setSelectProject', val);
      this.selectReportTypeId = null;
      this.requestReportTypes();
    },
    // selectReportTypeId() {
    //   this.reportTypeChange();
    // },
    selectDate() {
      this.requestReportDetail();
    },
    projectList() {
      this.initialData();
    },
    periodType() {
      this.selectDate = this.getInitialPeriod();
    },
  },
  computed: {
    projectList() {
      return this.$store.getters.projectList;
    },
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    reportTypeChange() {
      this.getSelectReportType();
      this.requestReportDetail();
    },
    spanMethod({
      row, column,
    }) {
      if (row.multi) {
        const spanInfo = row.multi.find((item) => item.prop === column.property);
        if (spanInfo) {
          return [
            parseInt(spanInfo.rows, 10),
            parseInt(spanInfo.cols, 10),
          ];
        }
        if (column.type === 'index') {
          return [1, 1];
        }
        return [1, 0];
      }
      return [1, 1];
    },
    getInitialPeriod() {
      let period = '';
      switch (this.periodType) {
        case 'date':
          period = formatDate(new Date(), 'yyyy-MM-dd');
          break;
        case 'week':
          period = formatDate(new Date(), 'yyyy-WW');
          break;
        case 'month':
          period = formatDate(new Date(), 'yyyy-MM');
          break;
        case 'year':
          period = formatDate(new Date(), 'yyyy');
          break;
        case 'daterange':
          period = [formatDate(new Date(), 'yyyy-MM-01'), formatDate(new Date(), 'yyyy-MM-dd')];
          break;
        default:
          break;
      }
      return period;
    },
    getSelectReportType() {
      console.log('this.reportTypes', this.reportTypes);
      this.selectReportType = this.reportTypes.find(
        (type) => type.ReportId === this.selectReportTypeId,
      );
      let type = 'date';
      if (this.selectReportType == null) {
        this.periodType = type;
      } else {
        switch (this.selectReportType.PeriodType) {
          case 0:
            type = 'date';
            break;
          case 1:
            type = 'week';
            break;
          case 2:
            type = 'month';
            break;
          case 3:
            type = 'year';
            break;
          case 4:
            type = 'daterange';
            break;
          default:
            break;
        }
        this.periodType = type;
      }
    },
    // 获取报告详情
    requestReportDetail() {
      this.reportDetail = null;
      const [start, end] = this.getStartEndList();
      getReportDetail({
        ProjectIdStr: this.selectProjectId,
        ReportId: this.selectReportTypeId,
        Date_Begin: start,
        Date_End: end,
      }).then((res) => {
        this.$nextTick(() => {
          this.reportDetail = res;
        });
      }).catch(() => {
        this.reportDetail = null;
      });
    },
    isNotSuitablePeriod() {
      let isNotSuitablePeriod = false;
      switch (this.selectReportType.PeriodType) {
        case 4:
          if (!Array.isArray(this.selectDate)) {
            isNotSuitablePeriod = true;
          }
          break;
        default:
          if (Array.isArray(this.selectDate)) {
            isNotSuitablePeriod = true;
          }
          break;
      }
      return isNotSuitablePeriod;
    },
    getStartEndList() {
      let startEndArr = [];
      switch (this.periodType) {
        case 'date':
        case 'week':
        case 'month':
        case 'year':
          startEndArr = [this.selectDate, null];
          break;
        case 'daterange':
          startEndArr = this.selectDate;
          break;
        default: break;
      }
      return startEndArr;
    },
    onSubmit() {
      this.requestReportDetail();
    },
    // 请求报告类型
    requestReportTypes() {
      getReportTypes({
        ProjectIdStr: this.selectProjectId,
      }).then((res) => {
        // 请求报告类型
        this.reportTypes = res;
        this.selectReportTypeId = res[0].ReportId;
        switch (res[0].PeriodType) {
          case 0:
            this.periodType = 'date';
            break;
          case 1:
            this.periodType = 'week';
            break;
          case 2:
            this.periodType = 'month';
            break;
          case 3:
            this.periodType = 'year';
            break;
          case 4:
            this.periodType = 'daterange';
            break;
          default:
            break;
        }
        this.requestReportDetail();
      });
    },
    initialData() {
      const { selectProject } = this.$store.getters;
      if (selectProject) {
        this.selectProjectId = selectProject;
      } else {
        const [{ IdStr }] = this.projectList;
        this.selectProjectId = IdStr;
      }
    },
    // 请求数据列表
    requestProjectList() {
      if (this.projectList !== null) {
        this.initialData();
        return;
      }
      this.$store.dispatch('projects/projectList');
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
  },
};
</script>
<style>
.header-text>.cell{
  text-align:center;
}
.el-table th.header-text>.cell{
  text-align:center;
}
</style>
